import {
  ApiAgentGatewaySpendPolicyController,
  ApiDemoControllerV2,
  ApiLegalDocumentController,
  ConsentControllerV2,
  HttpClient,
  LeadController,
} from '@getmoss/api-gateway'
import axios from 'axios'
import {useMemo} from 'react'
import {useGetConfig} from 'src/common/hooks/useGetConfig'
import {logApiError} from './logApiError'

export const useMossApi = ({headers = {}}: {headers?: Record<string, string>}) => {
  const config = useGetConfig()

  // Serialize headers to avoid unnecessary re-creations when {} is passed each render
  const headersKey = JSON.stringify(headers)

  const mossApi = useMemo(() => {
    const httpClient = axios.create({
      baseURL: config.API_URL,
      timeout: 60000,
      headers,
    })

    httpClient.interceptors.response.use(undefined, logApiError)

    const client = new HttpClient()

    client.instance = httpClient

    return {
      apiAgentGatewaySpendPolicyController: new ApiAgentGatewaySpendPolicyController(client),
      apiDemoController: new ApiDemoControllerV2(client),
      consentsController: new ConsentControllerV2(client),
      leadController: new LeadController(client),
      consentControllerV2: new ConsentControllerV2(client),
      apiLegalDocumentController: new ApiLegalDocumentController(client),
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps -- headersKey captures headers changes
  }, [config.API_URL, headersKey])

  return {mossApi}
}
